import {
    ThematicScheme,
    DBxEvent,
    ThematicSchemeManager,
    RGBA,
    DataQuery
  } from "cartovista";
  import {show} from "cartovistaExtend/appTools/Alerts";
  import { updateSectors, addSectors, deleteSectors } from "cartovistaExtend/utils/ServerRequests";

    //Permet de trier les éléments d'une thématiques par IndividualValues (secteur avec code EXT se trouve en dernière position)
    ThematicScheme.prototype.sortSchemeElements = function() {
        this._individualValueSchemeElements = _.sortBy(this._individualValueSchemeElements, function(n) {
            if (n.value === "EXT_EXT") {
                return null;
            } else {
                return n.value;
            }
        });
    };

    //Permet de trier les éléments d'une thématique par IndividualValues après avoir ajouté un nouvel élément
    ThematicScheme.prototype.addSchemeElementAndSort = function(e, i, r) {
        this.addIndividualValueSchemeElement(e, i, r);
        this.sortSchemeElements();
    };

    //TODO utiliser les styles au lieu des themeSet (quand bug dans cartoVista layer.addStyle() sera corrigé) pour plus de performance lorsque beaucoups de features
    class SectorData {
        constructor(sectorAttributes){
            this.attributes = sectorAttributes;
            this._descriptionDirty = false;
            this._selected = false;
            this._featuresIdsDirty = true;
            this._featuresIds = [];
            this._prevFeaturesIds = [];
            this. _featuresDirty = true;
            this._features = [];
            this._sumDirty = true;
            this. _sum = null;
            Object.defineProperties(this, {
                "guid": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.ID]; },
                    set(value){ this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.ID] = value;}
                },
                "id": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.ID].replace(/[{}]/g, ''); },
                },
                "name": {
                    get(){
                        if (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS) {
                            return _.upperFirst(C.LOCALES.SECTORS.GROUP.NAMES.SHORT_SINGLE) + " " + this.group + " - " + _.upperFirst(C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE) + " " + this.code;
                        } else {
                            return this.code != "EXT" ? _.upperFirst(C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE) + " " + this.code : this.code;
                        }
                    },
                },
                "scenario": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.SCENARIO]; },
                },
                "group": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP]; },
                    set(value){
                        this.dirty = true;
                        this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP] = value;
                    }
                },
                "code": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE]; },
                    set(code){
                        window.sectorsDataStore._deleteSectorSchemeElement(this);
                        var existingSectorData = window.sectorsDataStore.getSectorsData(this.scenario, C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS ? this.group : code, code);
                        if (typeof existingSectorData != "undefined") {
                            existingSectorData.dirty = true;
                            window.sectorsDataStore.deleteSectorData(this);
                            this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP] = C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS ? this.group : code;
                            this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE] = code;
                        } else {
                            this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP] = C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS ? this.group : code;
                            this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE] = code;
                            window.sectorsDataStore._addSectorSchemeElement(this);
                            window.sectorsDataStore._updateSectors([this], [C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE]);
                        }
                        window.cartovista.dispatchEvent(new DBxEvent("SectorsDatastore_SectorDataCodeChanged", this));
                    }
                },
                "themeIndValue": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP] + "_" + this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE]; },
                },
                "color": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.COLOR]; },
                    set(color){
                        window.sectorsDataStore._deleteSectorSchemeElement(this);
                        this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.COLOR] = color;
                        window.sectorsDataStore._addSectorSchemeElement(this);
                        window.sectorsDataStore._updateSectors([this], [C.DATASTORES.SECTORS_DATA.ATTRIBUTES.COLOR]);
                    }
                },
                "description": {
                    get(){ return this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.DESCRIPTION] ? this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.DESCRIPTION].replace(/<br\s*[\/]?>/gi, "\n") : null; },
                    set(description){
                        //remplace les \n par <br> en raison du bug esri arcpy.SetParameter
                        this.attributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.DESCRIPTION] = description ? description.replace(/\n/g, "<br>") : description;
                        this.descriptionDirty = true;
                    }
                },
                "descriptionDirty": {
                    get(){ return this._descriptionDirty; },
                    set(bool){
                        this._descriptionDirty = bool;
                        window.cartovista.dispatchEvent(new DBxEvent("SectorsDatastore_SectorDataDescriptionDirtyChanged", this));
                    }
                },
                "selected": {
                    get(){ return this._selected; },
                    set(bool){
                        if (bool === true) {
                            var selectedSectorData = window.sectorsDataStore.getSelectedSector(this.scenario);
                            if (selectedSectorData) {
                                selectedSectorData._selected = false;
                            }
                        }
                        this._selected = bool;
                    }
                },
                "features": {
                    get(){
                        if (this._featuresDirty) {
                            window.sectorsDataStore._pointsLayer.getFeatures(this.featuresIds, function(result) {
                                this._features = result.features;
                            }, this, false);
                            this._featuresDirty = false;
                        }
                        return this._features;
                    },
                },
                "featuresIds": {
                    get(){
                        if (this._featuresIdsDirty) {
                            var q = new DataQuery(window.sectorsDataStore._pointsLayerDataTable.getDataColumns([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[this.scenario].THEME]), null);
                            q.searchCriteria = this.themeIndValue;
                            q.execute(function(result) {
                                this._featuresIds = result.linkingIds;
                            }, this);
                            this._featuresIdsDirty = false;
                        }
                        return this._featuresIds;
                    },
                },
                "prevFeaturesIds": {
                    get(){ return this._prevFeaturesIds; }
                },
                "prevEnabled": {
                    get(){
                        if (this._prevFeaturesIds.length > 0) {
                            return true;
                        } else {
                            return false;
                        }
                    },
                    set(bool){
                        this._prevEnabled = bool;
                        if (!this._prevEnabled) {
                            this._prevFeaturesIds = [];
                        }
                    }
                },
                "sum": {
                    get(){
                        if (this._sumDirty) {
                            if (this.featuresIds.length) {
                                var q = new DataQuery([window.sectorsDataStore._pointsLayerSumField], this.featuresIds, ["SUM"]);
                                //q.statisticsOnly = true; //bugg CV7.4
                                q.execute(function(result) {
                                    this._sum = result.statisticsValues[window.sectorsDataStore._pointsLayerDataTable.id][window.sectorsDataStore._pointsLayerSumField.id].SUM ? result.statisticsValues[window.sectorsDataStore._pointsLayerDataTable.id][window.sectorsDataStore._pointsLayerSumField.id].SUM : 0;
                                }, this);
                                this._sumDirty = false;
                            } else {
                                this._sum = 0;
                            }
                        }
                        return this._sum;
                    },
                },
                "dirty": {
                    set(bool){
                        this._featuresIdsDirty = bool;
                        this._featuresDirty = bool;
                        this._sumDirty = bool;
                    }
                }
            });
        }
    };
    
    class SectorDataGroup{
        constructor(scenario, group) {
            this._scenario = scenario;
            this._group = group;
            this._collapsed = true;
            Object.defineProperties(this, {
                "scenario": {
                    get(){ return this._scenario; }
                },
                "group": {
                    get(){ return this._group; }
                },
                "sectorsData": {
                    get(){ return window.sectorsDataStore.getSectorsData(this.scenario, this.group);}
                },
                "featuresIds": {
                    get(){
                        var featuresIds = [];
                        this.sectorsData.map(function(sectorData) {
                            featuresIds = featuresIds.concat(sectorData.featuresIds);
                        });
                        return featuresIds;
                    }
                },
                "features": {
                    get(){
                        var features = [];
                        this.sectorsData.map(function(sectorData) {
                            features = features.concat(sectorData.features);
                        });
                        return features;
                    }
                },
                "sum": {
                    get(){
                        var sum;
                        var q = new DataQuery([window.sectorsDataStore._pointsLayerSumField], this.featuresIds, ["SUM"]);
                        //q.statisticsOnly = true; //bugg CV7.4
                        q.execute(function(result) {
                            sum = result.statisticsValues[window.sectorsDataStore._pointsLayerDataTable.id][window.sectorsDataStore._pointsLayerSumField.id].SUM ? result.statisticsValues[window.sectorsDataStore._pointsLayerDataTable.id][window.sectorsDataStore._pointsLayerSumField.id].SUM : 0;
                        });
                        return sum;
                    }
                },
                "collapsed": {
                    get(){ return this._collapsed; },
                    set(value){ this._collapsed = value;}
                },
                "name": {
                    get(){ return _.upperFirst(C.LOCALES.SECTORS.GROUP.NAMES.SHORT_SINGLE) + " " + this.group; }
                }
            });
        }
    };

    export default class SectorsDatastore {
        constructor(){
            this._data = {};
            this.initializeDataStore();
            window.cartovista.addEventListener("ReloadDataTool_ReloadStarted", this._onReloadDataStarted, this);
            window.cartovista.addOneTimeEventListener(C.PANELS.DECOUPAGE_PANEL.POINTS.LAYER_ID + "_layerCreated", this._onPointsLayerCreated, this);
    };

    deleteItems(){
        this.initializeDataStore();
    }

    initializeDataStore() {
        _.forEach(this.getSectorsData(), this._deleteSectorSchemeElement.bind(this));
        this._data = {};
        _.forEach(C.THEMESETS_ELEMENTS, function(themeSetElementConfig, scenarioId) {
            this._data[scenarioId] = {
                _scenario : scenarioId,
                _groups : [],
                _sectorsData : []
            };
        }.bind(this));
    };

    _onReloadDataStarted(evt) {
        this.initializeDataStore();
    };

    _onPointsLayerCreated(evt) {
        this._pointsLayer = evt.source.layer;
        this._pointsLayerDataTable = this._pointsLayer.getDataTable(C.PANELS.DECOUPAGE_PANEL.POINTS.DATATABLE_ID);
        this._pointsLayerSumField = this._pointsLayerDataTable.getDataColumns(C.PANELS.DECOUPAGE_PANEL.POINTS.SUM_DATACOLUMN_ID)[0];
    };

    getSectorsData(scenario, group, code) {
        if (!scenario) {
            var sectorsData = [];
            _.forEach(this._data, function(sectorsDataScenario) {
                sectorsData = _.union(sectorsData, sectorsDataScenario._sectorsData);
            });
            return sectorsData;
        } else if (!this._data.hasOwnProperty(scenario)) {
            throw new Error("SectorsDatastore.getSectorsData() - scenario id : " + scenario + " is invalid.");
        } else if (group && !code) {
            var sectorsData = _.filter(this._data[scenario]._sectorsData, function(sectorData) {
                return sectorData.group === group;
            });
            return this._sortSectorsData(sectorsData);
        } else if (group && code) {
            var sectorsData = _.filter(this._data[scenario]._sectorsData, function(sectorData) {
                return sectorData.group === group && sectorData.code === code;
             });
            if (sectorsData.length > 1) {
                throw new Error("SectorsDatastore.getSectorsData() - More than one sectorData with the same SCENARIO, GROUP and CODE.");
            } else {
                return sectorsData[0];
            }
        } else {
            return this._sortSectorsData(this._data[scenario]._sectorsData);
        }
    };

    getSectorsDataGroups(scenario, group) {
        if (!scenario || !this._data.hasOwnProperty(scenario)) {
            throw new Error("SectorsDatastore.getSectorsDataGroups() - scenario id : " + scenario + " is invalid.");
        } else if (group) {
            var sectorsDataGroups = _.filter(this._data[scenario]._groups, function(sectorsDataGroup) {
                return sectorsDataGroup.group === group;
            });
            if (sectorsDataGroups.length > 1) {
                throw new Error("SectorsDatastore.getSectorsDataGroups() - More than one sectorsDataGroup group : " + group);
            } else {
                return sectorsDataGroups[0];
            }
        } else {
            return this._sortSectorsDataGroups(this._data[scenario]._groups);
        }
    };

    setSectorsDataDirty(scenario, group, code) {
        return _.map(this.getSectorsData(scenario, group, code), function(sectorData) {
            sectorData.dirty = true;
            return sectorData;
        });
    };

    getSelectedSector(scenario) {
        return _.find(this.getSectorsData(scenario), {"selected" : true});
    };

    getPrevEnabledSectorsData(scenario, group) {
        return _.filter(this.getSectorsData(scenario, group), {"prevEnabled" : true});
    };

    _sortSectorsData(sectorsData) {
        return _.sortBy(sectorsData, function(sectorData) {
            if (sectorData.themeIndValue === "EXT_EXT") {
                return null;
            } else {
                return sectorData.themeIndValue;
            }
        });
    };

    _sortSectorsDataGroups(sectorsDataGroups) {
        return _.sortBy(sectorsDataGroups, ["group"]);
    };

    storeSectorData(sectorAttributes) {
        this._validateNewSectorAttributes(sectorAttributes);
        var sectorData = new SectorData(sectorAttributes);
        this._data[sectorData.scenario]._sectorsData.push(sectorData);
        this._addSectorSchemeElement(sectorData);

        if (typeof this.getSectorsDataGroups(sectorData.scenario, sectorData.group) === "undefined") {
            this._data[sectorData.scenario]._groups.push(new SectorDataGroup(sectorData.scenario, sectorData.group));
        }
        return sectorData;
    };

    addSectorData(scenario, group, code) {
        var sectorAttributes = {};
        sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.ID] = null;
        sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.SCENARIO] = scenario;
        sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP] = group;
        sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE] = code;
        sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.COLOR] = "rgba(" + _.random(0, 255) + "," + _.random(0, 255) + "," + _.random(0, 255) + ",1)";
        sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.DESCRIPTION] = null;
        var sectorData = this.storeSectorData(sectorAttributes);
        this._addSectors([sectorData]);

        if (typeof this.getSectorsDataGroups(sectorData.scenario, sectorData.group) === "undefined") {
            this._data[sectorData.scenario]._groups.push(new SectorDataGroup(sectorData.scenario, sectorData.group));
        }
        return sectorData;
    };

    _validateNewSectorAttributes(sectorAttributes) {
        if (!sectorAttributes.hasOwnProperty(C.DATASTORES.SECTORS_DATA.ATTRIBUTES.SCENARIO)) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - SCENARIO property missing.");
        }
        if (!sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.SCENARIO]) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - SCENARIO value is falsy.");
        }
        if (!sectorAttributes.hasOwnProperty(C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP)) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - GROUP property missing.");
        }
        if (!sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP]) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - GROUP value is falsy.");
        }
        if (!sectorAttributes.hasOwnProperty(C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE)) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - CODE property missing.");
        }
        if (!sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE]) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - CODE value is falsy.");
        }
        if (!this._data.hasOwnProperty(sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.SCENARIO])) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - Invalid SCENARIO field value.");
        }
        if (this.getSectorsData(sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.SCENARIO], sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP], sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE])) {
            throw new Error("SectorsDatastore._validateNewSectorData() error - sectorData with the same SCENARIO (" + sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.SCENARIO] +"), GROUP ("+ sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.GROUP] +") and CODE ("+ sectorAttributes[C.DATASTORES.SECTORS_DATA.ATTRIBUTES.CODE] +") already exists.");
        }
    };

    _addSectorSchemeElement(sectorData) {
        var scheme = ThematicSchemeManager.getThematicScheme("SCHEME_" + sectorData.scenario);
        scheme.addSchemeElementAndSort(sectorData.themeIndValue, new RGBA(sectorData.color).ole, sectorData.name);
    };

    _deleteSectorSchemeElement(sectorData) {
        var scheme = ThematicSchemeManager.getThematicScheme("SCHEME_" + sectorData.scenario);
        var deletedSchemeElement = _.remove(scheme._individualValueSchemeElements, function(schemeElement) {
            return schemeElement["_value"] === sectorData.themeIndValue;
        })[0];
        delete window.cartovista.getMap(C.MAP.ID).getThemeSet(sectorData.scenario).getThemeByIndex(0)._colorTheme._representationsMap[sectorData.themeIndValue];
        return deletedSchemeElement;
    };

    deleteSectorData(toDeleteSectorData) {
        this._deleteSectorSchemeElement(toDeleteSectorData);
        this._deleteSectors([toDeleteSectorData]);
        //remove toDeleteSectorData from sectorsDataStore
        _.remove(this._data[toDeleteSectorData.scenario]._sectorsData, function(sectorData) {
            return sectorData.group == toDeleteSectorData.group && sectorData.code == toDeleteSectorData.code;
        });
        //remove sectorsDataGroup from sectorsDataStore if empty
        _.remove(this._data[toDeleteSectorData.scenario]._groups, function(sectorsDataGroup) {
            return sectorsDataGroup.group == toDeleteSectorData.group && sectorsDataGroup.sectorsData.length == 0;
        });
        return toDeleteSectorData;
    };

    _getQueryExpression(sectorsData) {
        return {
            "LOGICAL_OPERATOR" : null,
            "QUERIES" : [
                {"FIELD" : "GUID", "OPERATOR" : (sectorsData.length > 1 ? "IN" : "="), "VALUE" : (sectorsData.length > 1 ? _.map(sectorsData, "guid") : sectorsData[0].guid)},
            ]
        };
    };

    _getFeaturesData(sectorsData, attributes) {
        return _.map(sectorsData, function(sectorData) {
            return {
                "geometry" : null,
                "attributes" : this._getFeaturesDataAttributes(sectorData, attributes)
            };
        }.bind(this));
    };

    _getFeaturesDataAttributes(sectorData, attributes) {
        if (typeof attributes != "undefined" && attributes.length) {
            var attributes = _.union(attributes, [C.DATASTORES.SECTORS_DATA.ATTRIBUTES.ID]);
            return _.zipObject(attributes, _.map(attributes, function(attr) {
                return sectorData.attributes[attr];
            }));
        } else {
            return sectorData.attributes;
        }
    };

    _onSectorsDataUpdated(evt) {
        var sectorsData = evt.source.sectorsData;
        var attributes = evt.source.attributes;
        this._updateSectors(evt.source.sectorsData, evt.source.attributes);
    };

    _updateSectors(sectorsData, attributes) {
        var codes = _.join(_.map(sectorsData, "code"), ", ");
        var groups = _.join(_.map(sectorsData, "group"), ", ");
        var title = sectorsData.lenght > 1 ? C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_PLURAL : C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE;
        return updateSectors(this._getQueryExpression(sectorsData), this._getFeaturesData(sectorsData, attributes))
            .then(function(guids) {
                show(sectorsData.lenght > 1 ? "SectorsDatastore_SectorsDataUpdated" : "SectorsDatastore_SectorDataUpdated", {"title": title, "sectorCodes": codes, "sectorGroups": groups, "scenario": C.THEMESETS_ELEMENTS[sectorsData[0].scenario].TITLE});
                return guids;
            });
    };

    _addSectors(sectorsData) {
        var codes = _.join(_.map(sectorsData, "code"), ", ");
        var groups = _.join(_.map(sectorsData, "group"), ", ");
        var title = sectorsData.lenght > 1 ? C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_PLURAL : C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE;
        return addSectors(this._getFeaturesData(sectorsData))
            .then(function(guids) {
                _.forEach(sectorsData, function(sectorData, idx) {
                    sectorData.guid = guids[idx];
                });
                show(sectorsData.lenght > 1 ? "SectorsDatastore_SectorsDataAdded" : "SectorsDatastore_SectorDataAdded", {"title": title, "sectorCodes": codes, "sectorGroups": groups, "scenario": C.THEMESETS_ELEMENTS[sectorsData[0].scenario].TITLE});
                window.cartovista.dispatchEvent(new DBxEvent("SectorsDatastore_SectorsDataAdded", sectorsData));
                return guids;
            });
    };

    _deleteSectors(sectorsData) {
        var codes = _.join(_.map(sectorsData, "code"), ", ");
        var groups = _.join(_.map(sectorsData, "group"), ", ");
        var title = sectorsData.lenght > 1 ? C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_PLURAL : C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE;
        return deleteSectors(this._getQueryExpression(sectorsData))
            .then(function(guids) {
                show(sectorsData.length > 1 ? "SectorsDatastore_SectorsDataDeleted" : "SectorsDatastore_SectorDataDeleted", {"title": title, "sectorCodes": codes, "sectorGroups": groups , "scenario": C.THEMESETS_ELEMENTS[sectorsData[0].scenario].TITLE});
                window.cartovista.dispatchEvent(new DBxEvent("SectorsDatastore_SectorsDataDeleted", sectorsData));
                return guids;
            });
    };

}
